import React, { useState, useEffect } from "react";

const Sidebar = ({
  projects,
  onSelectProject,
  onDeleteProject,
  onCreateProject,
  selectedProjectId,
  userEmail,
  onSignOut,
}) => {
  const [showOptions, setShowOptions] = useState(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".options-menu")) {
        setShowOptions(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <aside className="w-72 shrink-0 bg-navy-700 text-navy-50 flex flex-col h-screen sticky top-0">
      <div className="px-5 pt-6 pb-5 border-b border-navy-600">
        <div className="flex items-baseline gap-2">
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-navy-200">
            Timeline
          </span>
          <span className="font-mono text-[11px] text-navy-300">/</span>
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-rust-300">
            DPR
          </span>
        </div>
        <h1 className="mt-1 text-base font-semibold text-white">Projects</h1>
      </div>

      <nav className="flex-1 overflow-y-auto px-2 py-3">
        <ul className="space-y-0.5">
          {projects.map((project) => {
            const isSelected = project.id === selectedProjectId;
            return (
              <li key={project.id} className="relative">
                <button
                  type="button"
                  onClick={() => onSelectProject(project.id)}
                  className={`group flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm transition-colors ${
                    isSelected
                      ? "bg-navy-600 text-white"
                      : "text-navy-100 hover:bg-navy-600/60 hover:text-white"
                  }`}
                >
                  <span className="truncate">
                    {project.title || "Untitled Project"}
                  </span>
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowOptions(
                        showOptions === project.id ? null : project.id
                      );
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowOptions(
                          showOptions === project.id ? null : project.id
                        );
                      }
                    }}
                    className={`ml-2 px-1.5 text-navy-300 hover:text-white ${
                      isSelected ? "text-navy-200" : ""
                    }`}
                    aria-label="Project options"
                  >
                    ⋯
                  </span>
                </button>

                {showOptions === project.id && (
                  <div className="options-menu absolute right-2 top-full z-10 mt-1 w-32 overflow-hidden rounded-md border border-navy-200 bg-white text-zinc-800 shadow-lg">
                    <button
                      className="block w-full px-3 py-2 text-left text-sm hover:bg-zinc-50"
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectProject(project.id);
                        setShowOptions(null);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="block w-full px-3 py-2 text-left text-sm text-rust-600 hover:bg-rust-50"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteProject(project.id);
                        setShowOptions(null);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="border-t border-navy-600 px-5 py-4 space-y-3">
        <button
          onClick={onCreateProject}
          className="w-full rounded-md bg-rust-500 px-3 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-rust-600 focus:outline-none focus:ring-2 focus:ring-rust-300 focus:ring-offset-2 focus:ring-offset-navy-700"
        >
          + New Project
        </button>
        <div className="flex items-center justify-between text-xs">
          {userEmail && (
            <span className="truncate text-navy-200" title={userEmail}>
              {userEmail}
            </span>
          )}
          <button
            onClick={onSignOut}
            className="ml-2 shrink-0 font-medium text-navy-200 hover:text-white"
          >
            Sign out
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
